module.exports = __webpack_public_path__ + "static/media/image-11.5b3e6fc2.jpg";